import { Modal, Button } from 'react-bootstrap';
import type { Manual } from '../../../infrastructure/ManualClient';

interface DeleteManualModalProps {
  show: boolean;
  manual: Manual;
  onHide: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

export const DeleteManualModal = ({ show, manual, onHide, onConfirm, isDeleting }: DeleteManualModalProps) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Manual</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to delete the manual <strong>"{manual.title}"</strong>?
        </p>
        <p className="text-danger">This action cannot be undone.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isDeleting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
